import { render } from "./KuboardSprayLink.vue?vue&type=template&id=47034f8c"
import script from "./KuboardSprayLink.vue?vue&type=script&lang=js"
export * from "./KuboardSprayLink.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__